import { REDUX_SLICE } from '../constants';
import { analyticsApi } from '../services/analytics.service';
import { networkApi } from '../services/network.service';
import { otcApi } from '../services/otc.service';
import { priceApi } from '../services/price.service';
import { projectDashboardApi } from '../services/project-dashboard.service';
import { projectApi } from '../services/project.service';
import { roleApi } from '../services/role.service';
import { uploadApi } from '../services/upload.service';
import { voteApi } from '../services/vote.service';
import { appSlice } from '../slices/app.slice';

export const reducer = {
  [REDUX_SLICE.APP]: appSlice.reducer,
  [REDUX_SLICE.PROJECT_API]: projectApi.reducer,
  [REDUX_SLICE.UPLOAD_API]: uploadApi.reducer,
  [REDUX_SLICE.ROLE_API]: roleApi.reducer,
  [REDUX_SLICE.VOTE_API]: voteApi.reducer,
  [REDUX_SLICE.OTC_API]: otcApi.reducer,
  [REDUX_SLICE.NETWORK_API]: networkApi.reducer,
  [REDUX_SLICE.ANALYTICS_API]: analyticsApi.reducer,
  [REDUX_SLICE.PROJECT_DASHBOARD_API]: projectDashboardApi.reducer,
  [REDUX_SLICE.PRICE_API]: priceApi.reducer,
};
